module.exports = __webpack_public_path__ + "60139512e87e5576889b174c8ff9232f.svg";